import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	coords: null,
	permission: null,
  logs: null,
  location: null,
  isShowWarning: false,
};

const gps = createSlice({
	name: 'gps',
	initialState,
	reducers: {
		setGps: (state, action) => {
			return { ...state, ...action.payload };
		},
		clearGps: () => {
			return initialState;
		},
	},
});

export const { setGps, clearGps } = gps.actions;
export default gps.reducer;
